import React from 'react';
import './styles';

export const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  )
}
